import { inject } from '@angular/core';

import { ApolloLink, NextLink, Observable, Operation } from '@apollo/client/core';

import { TokenService } from '@hdms/shared/util-core';

/**
 * The link is delaying incoming operation requests as long init preconditions aren't met,
 * which are waiting for TokenService being ready. But any additional ones could be added too.
 */
export function createReadyLink(): ApolloLink {
  const tokenService = inject(TokenService);
  let ready = false;

  return new ApolloLink((operation: Operation, forward: NextLink) =>
    ready
      ? forward(operation)
      : new Observable(obs => {
          tokenService.ready$.subscribe(() => {
            forward(operation).subscribe(obs);
            ready = true;
          });
        })
  );
}
